import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import './Auth.css';

const Login = () => {
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('📍 Login.js: Starting login...');
      const userData = await login(formData.username, formData.password);
      console.log('📍 Login.js: Login successful, user role:', userData.user_role);
      
      toast.success(t('loginSuccess'));
      
      // Redirect based on user role
      if (userData.user_role === 'superadmin' || userData.user_role === 'admin') {
        console.log('📍 Login.js: Redirecting admin to /admin-panel');
        navigate('/admin-panel');
      } else if (userData.user_role === 'owner') {
        console.log('📍 Login.js: Redirecting owner to /dashboard');
        navigate('/dashboard');
      } else {
        console.log('📍 Login.js: Redirecting seller to /pos');
        navigate('/pos'); // sellers go to POS
      }
    } catch (error) {
      console.error('📍 Login.js: Error:', error);
      const errorMsg = error.response?.data?.error || error.message || t('loginError');
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">{t('login')}</h1>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>{t('username')}</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="form-control"
              autoComplete="username"
              required
            />
          </div>

          <div className="form-group">
            <label>{t('password')}</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-control"
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? '...' : t('signIn')}
          </button>
        </form>

        <div className="auth-footer">
          {t('dontHaveAccount')} <Link to="/register">{t('signUp')}</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
